module.exports = "/_next/static/images/kisurin_taketout-7a5a83bb3500798d8f14c28da6db7d65.jpg";